import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "reactstrap";
import alertActions from "../actions/alertActions";
import alertConstants from "../constants/alertConstants";

const Alerts = (props) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(true);
  const alert = useSelector((state) => state.alert);

  useEffect(() => {
    if (Object.keys(alert).length !== 0) {
      setVisible(true);
      window.setTimeout(() => {
        setVisible(false);
        dispatch(alertActions.clear());
      }, 5000);
    }
  }, [alert]);

  const toggle = () => {
    setVisible(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: "0",
        right: "0",
        zIndex: "100000",
        opacity: ".8",
      }}
    >
      {props.alert.type === alertConstants.SUCCESS && (
        <Alert
          color="success"
          isOpen={visible}
          toggle={() => {
            toggle();
          }}
        >
          <b>{props.alert.type}</b> - {props.alert.message}
        </Alert>
      )}
      {props.alert.type === alertConstants.ERROR && (
        <Alert
          color="danger"
          isOpen={visible}
          toggle={() => {
            toggle();
          }}
        >
          <b>{props.alert.type}</b> - {props.alert.message}
        </Alert>
      )}
      {props.alert.type === alertConstants.NOTICE && (
        <Alert
          color="info"
          isOpen={visible}
          toggle={() => {
            toggle();
          }}
        >
          <b>{props.alert.type}</b> - {props.alert.message}
        </Alert>
      )}
    </div>
  );
};

export default Alerts;
